/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FacilityCustomTag } from './FacilityCustomTag';
import {
    FacilityCustomTagFromJSON,
    FacilityCustomTagFromJSONTyped,
    FacilityCustomTagToJSON,
    FacilityCustomTagToJSONTyped,
} from './FacilityCustomTag';

/**
 * 
 * @export
 * @interface CreateFacilityCustomTag201Response
 */
export interface CreateFacilityCustomTag201Response {
    /**
     * 
     */
    data?: FacilityCustomTag;
}

/**
 * Check if a given object implements the CreateFacilityCustomTag201Response interface.
 */
export function instanceOfCreateFacilityCustomTag201Response(value: object): value is CreateFacilityCustomTag201Response {
    return true;
}

export function CreateFacilityCustomTag201ResponseFromJSON(json: any): CreateFacilityCustomTag201Response {
    return CreateFacilityCustomTag201ResponseFromJSONTyped(json, false);
}

export function CreateFacilityCustomTag201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateFacilityCustomTag201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : FacilityCustomTagFromJSON(json['data']),
    };
}

export function CreateFacilityCustomTag201ResponseToJSON(json: any): CreateFacilityCustomTag201Response {
    return CreateFacilityCustomTag201ResponseToJSONTyped(json, false);
}

export function CreateFacilityCustomTag201ResponseToJSONTyped(value?: CreateFacilityCustomTag201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': FacilityCustomTagToJSON(value['data']),
    };
}

